import { allowedModules, APP_MODULES } from 'constants/appModules';
import { allowedEddrModules, EDDR_MODULES } from 'constants/eddrModules';
import { PATHS } from 'constants/paths';
import { isReportingPartner } from 'helpers/UserHelper';
import { getEddrModuleFromPath, getModuleFromPath } from 'helpers/pathParser';
import { FC, useEffect, useState } from 'react';
import { generatePath, Redirect, useHistory, useRouteMatch } from 'react-router-dom';
import { useSelectUser } from 'redux/User/selectors';
import { useSelectCurrentWell, useSelectCurrentWellbore } from 'redux/Wells/selectors';
import { WellFullDetailsDTO } from 'types/well';

const AuthorizedModule: FC = ({ children }) => {
  const user = useSelectUser();
  const history = useHistory();
  const match = useRouteMatch();
  const currentModule = getModuleFromPath(match.path);
  const currentWellbore = useSelectCurrentWellbore();
  const currentWell: WellFullDetailsDTO | undefined = useSelectCurrentWell();
  const [isModuleEnabledForUser, setModuleEnabledForUser] = useState(true);
  const currentEddrModule =
    currentModule === APP_MODULES.EDDR ? getEddrModuleFromPath(match.path) : null;

  useEffect(() => {
    if (
      user &&
      isReportingPartner(user.profile) &&
      currentEddrModule &&
      (currentWell || currentWellbore) &&
      !allowedEddrModules[user.profile].includes(currentEddrModule)
    ) {
      if (
        currentWell?.tuwi &&
        (allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_OPERATIONS_LOG ||
          allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_FLUIDS ||
          allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_BHA ||
          allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_TRAJECTORY ||
          allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_SAFETY ||
          allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_WELL_ACTIVITY_HISTORY ||
          allowedEddrModules[user.profile][0] === EDDR_MODULES.EDDR_OVERVIEW)
      ) {
        history.push(
          generatePath(PATHS[allowedEddrModules[user.profile][0]], {
            tuwi: currentWell.tuwi,
          }),
        );
      } else if (currentWellbore?.wellboreId) {
        history.push(
          generatePath(PATHS[allowedEddrModules[user.profile][0]], {
            wellboreId: currentWellbore.wellboreId,
          }),
        );
      } else {
        history.push(generatePath(PATHS.HOME));
      }
    } else if (user && currentModule) {
      setModuleEnabledForUser(
        allowedModules[user.profile].some(moduleName => currentModule === moduleName),
      );
    }
  }, [currentModule, currentEddrModule, user, history, currentWellbore, currentWell]);

  return isModuleEnabledForUser ? <>{children}</> : <Redirect exact to={PATHS.HOME} />;
};

export default AuthorizedModule;
